import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import QuestionBlueIcon from './icons/QuestionBlueIcon.jsx';

const OrgStructureCurrentCSVDownloadButton = ({ onDownloadCsv }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);

  const handleShow = () => setShowModal(true);

  const renderModal = () => (
    <Modal bsSize="sm" show={showModal} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          Use the following steps to bulk upload groups and employees to the
          Organization Structure:
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ol>
          <li className="text-muted">
            Download the current Organization Structure CSV below.
          </li>
          <li className="text-muted">
            Edit the CSV and add the group and employee details you want to
            include in the Organization Structure.
          </li>
          <li className="text-muted">
            Save the edited or new file as a CSV and upload it to ChangeSync.
          </li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button block bsStyle="primary" onClick={onDownloadCsv} target="_blank">
          Download Organization Structure CSV
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return (
    <React.Fragment>
      <button
        aria-label="View help"
        type="button"
        className="btn-clear flex flex-align-center text-left p-0 text-muted"
        onClick={handleShow}
      >
        Need a Current Organization Structure CSV? Click the question mark to
        download.&nbsp;
        <div className="m-l-8">
          <QuestionBlueIcon />
        </div>
      </button>
      {renderModal()}
    </React.Fragment>
  );
};

export default OrgStructureCurrentCSVDownloadButton;
